import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./feature-modern-slavery-hub.module.css";
export const ModernSlaveryHub = ({ links  })=>/*#__PURE__*/ _jsx("div", {
        className: styles.linkContainer,
        children: /*#__PURE__*/ _jsx(Wrapper, {
            isSlim: true,
            children: /*#__PURE__*/ _jsx("ul", {
                children: links.sort((a, b)=>Number(b.name) - Number(a.name)).map((link)=>/*#__PURE__*/ _jsx("li", {
                        className: styles.link,
                        children: /*#__PURE__*/ _jsxs("a", {
                            href: `/${link.slug.replace("statements/", "")}`,
                            children: [
                                "Modern slavery statement ",
                                link.name
                            ]
                        })
                    }, link.name))
            })
        })
    });
